import { States } from 'safe'
import {
  ADD_TRANSFER,
  SET_TRANSFERS,
  TransactionTypes,
} from '../actions/actionTypes'

const initialState: States.Transfer = {
  transfers: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: TransactionTypes
): States.Transfer => {
  switch (action.type) {
    case SET_TRANSFERS:
      return { ...state, transfers: action.payload }
    case ADD_TRANSFER:
      return { ...state, transfers: [...state.transfers, action.payload] }
    default:
      return state
  }
}
